import { MutationHookOptions } from '@apollo/client';

import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import {
  ApproveBankTransferRequestDocument,
  ApproveBankTransferRequestMutation,
  ApproveBankTransferRequestMutationVariables,
} from './approveBankTransferRequest.gql';

type Options = MutationHookOptions<
  ApproveBankTransferRequestMutation,
  ApproveBankTransferRequestMutationVariables
>;

export const useApproveBankTransferRequest = (options?: Options) =>
  useErrorHandledMutation<
    ApproveBankTransferRequestMutation,
    ApproveBankTransferRequestMutationVariables
  >(ApproveBankTransferRequestDocument, {
    notifyOnNetworkStatusChange: true,
    ...options,
  });
